<div class="toast hide" style="position: absolute; top: 0; right: 0;" data-delay="8000">
  <div class="toast-header">
    <div [class]="'rounded me-2 ' + message.class" style="height: 16px;width: 16px;"></div>
    <strong class="me-auto">neocrédito</strong>
    <button type="button" class="ms-2 mb-1 close" data-bs-dismiss="toast" aria-label="Close">
      
    </button>
  </div>
  <div class="toast-body">
    {{ message.text }}
  </div>
</div>
